/*
 * @Author: liugezhou
 * @Date: 2022-04-19 09:08:15
 * @LastEditors: liugezhou
 * @LastEditTime: 2022-04-21 20:59:01
 * @FilePath: /euc-enroll/src/store/index.js
 * @Description: 
 */
import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
Vue.use(Vuex)

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js